import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { Card, Field } from '../Fuse';
import NewFuseWysiwyg from '../Fuse/NewFuseWysiwyg';
import FuseRadioButton from '../FuseControls/FuseRadioButton';
import BaseCustomizeEditModal from './BaseCustomizeEditModal';
import FuseConsoleCardFooter from '../ConsoleFragments/FuseConsoleCardFooter';
import { BlockPageEnabledField, BlockPageEnabledView } from './BlockPageFields';

class CustomizeBlockPageModal extends Component {
    static propTypes = {
        store: PropTypes.any,
        enableTooltip: PropTypes.string,
    };

    render() {
        const { store } = this.props;
        return <BaseCustomizeEditModal store={store}>
            <Card title={store.metadata.name}>
                <BlockPageEnabledField
                    tooltipProps={{ position: 'right' }}
                    tooltip={this.props.enableTooltip}
                >
                    {['DEFAULT', 'CUSTOM'].map((value) => <FuseRadioButton
                        key={value}
                        store={store.enabled}
                        value={value === 'CUSTOM'}
                        label={BlockPageEnabledView[value]}
                        qa={`block-page-enabled-${value}`}
                    />)}
                </BlockPageEnabledField>
                {store.enabled.getValue() ? <>
                    <Field label="Message (required)">
                        <NewFuseWysiwyg store={store.content} />
                    </Field>
                    <FuseConsoleCardFooter text="Text will not be translated to other languages." />
                </> : null}
            </Card>
        </BaseCustomizeEditModal>;
    }
}
export default inject('customizeUI')(observer(CustomizeBlockPageModal));
